import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Organization } from '@/types/organization';

type CreateOrganizationRequest = {
  token: string;
  name: string;
};

type CreateOrganizationResponse = Organization;

const createOrganizationFetcher = async (
  url: string,
  { arg }: { arg: CreateOrganizationRequest }
): Promise<CreateOrganizationResponse> =>
  await denApi.post<CreateOrganizationResponse, CreateOrganizationRequest>(
    url,
    arg
  );

export function useCreateOrganization(
  swrOptions?: SWRMutationConfiguration<
    CreateOrganizationResponse,
    Error,
    string,
    CreateOrganizationRequest
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    CreateOrganizationResponse,
    Error,
    string,
    CreateOrganizationRequest
  >('organization/create', createOrganizationFetcher, swrOptions);

  return { create: trigger, isLoading: isMutating, error };
}
